module.exports = __webpack_public_path__ + "static/media/ci-2.fb8654d3.jpg";